import { css } from 'styled-components';
import { Text02 } from './colors';
/**
 * @deprecated
 */
export const BodyLong01 = css`
  font-size: var(--font-size-base);
  line-height: var(--line-height-body-long-01);
`;
/**
 * @deprecated
 */
export const ProductiveHeading08 = css`
  font-size: var(--font-size-sm);
  font-weight: var(--heading-8-weight);
  line-height: var(--heading-8-line-height);
`;
/**
 * @deprecated
 */
export const ProductiveHeading07 = css`
  font-size: var(--font-size-base);
  font-weight: var(--heading-7-weight);
  line-height: var(--heading-7-line-height);
`;
/**
 * @deprecated
 */
export const ProductiveHeading06 = css`
  font-size: var(--heading-6-size);
  font-weight: var(--heading-6-weight);
  line-height: var(--heading-6-line-height);
`;
/**
 * @deprecated
 */
export const ProductiveHeading05 = css`
  font-size: var(--heading-5-size);
  font-weight: var(--heading-5-weight);
  line-height: var(--heading-5-line-height);
`;
/**
 * @deprecated
 */
export const ProductiveHeading04 = css`
  font-size: var(--heading-4-size);
  font-weight: var(--heading-4-weight);
  line-height: var(--heading-4-line-height);
`;
/**
 * @deprecated
 */
export const ProductiveHeading03 = css`
  font-size: var(--heading-3-size);
  font-weight: var(--heading-3-weight);
  line-height: var(--heading-3-line-height);
`;
/**
 * @deprecated
 */
export const ProductiveHeading02 = css`
  font-size: var(--heading-2-size);
  font-weight: var(--heading-2-weight);
  line-height: var(--heading-2-line-height);
`;
/**
 * @deprecated
 */
export const ProductiveHeading01 = css`
  font-size: var(--heading-1-size);
  font-weight: var(--heading-1-weight);
  line-height: var(--heading-1-line-height);
`;
/**
 * @deprecated
 */
export const ProductiveCompact01 = css`
  font-size: var(--font-size-base);
  font-weight: var(--heading-6-weight);
  line-height: var(--heading-7-line-height);
`;
export const HeadingCompact00 = css`
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-02);
  letter-spacing: var(--letter-spacing-01);
`;
export const HeadingCompact01 = css`
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-05);
  letter-spacing: var(--letter-spacing-01);
`;
export const HeadingCompact02 = css`
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-04);
  letter-spacing: var(--letter-spacing-00);
`;
export const Heading01 = css`
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-03);
  letter-spacing: var(--letter-spacing-00);
`;
export const Heading02 = css`
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-05);
  letter-spacing: var(--letter-spacing-00);
`;
export const Heading03 = css`
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold) !important;
  line-height: var(--line-height-06);
  letter-spacing: var(--letter-spacing-00);
`;
export const Heading04 = css`
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-06);
  letter-spacing: var(--letter-spacing-00);
`;
export const Heading05 = css`
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-06);
  letter-spacing: var(--letter-spacing-00);
`;
export const Heading06 = css`
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-06);
  letter-spacing: var(--letter-spacing-00);
`;
export const Heading07 = css`
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-06);
  letter-spacing: var(--letter-spacing-00);
`;
export const Code01 = css`
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-01);
  letter-spacing: var(--letter-spacing-02);
`;
export const Code02 = css`
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-03);
  letter-spacing: var(--letter-spacing-02);
`;
export const Label01 = css`
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semi-bold);
  line-height: var(--line-height-01);
  letter-spacing: var(--letter-spacing-02);
`;
export const Label02 = css`
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-05);
  letter-spacing: var(--letter-spacing-01);
`;
export const HelperText01 = css`
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-01);
  letter-spacing: var(--letter-spacing-00);
`;
export const HelperText02 = css`
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-02);
  letter-spacing: var(--letter-spacing-01);
`;
export const Short00 = css`
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-01);
  letter-spacing: var(--letter-spacing-00);
`;
export const Short01 = css`
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-02);
  letter-spacing: var(--letter-spacing-01);
`;
export const Short02 = css`
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-04);
  letter-spacing: var(--letter-spacing-00);
`;
export const ShortSB = css`
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semi-bold);
  line-height: var(--line-height-02);
  letter-spacing: var(--letter-spacing-00);
`;
export const Long01 = css`
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-02);
  letter-spacing: var(--letter-spacing-01);
`;
export const Long02 = css`
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-05);
  letter-spacing: var(--letter-spacing-00);
`;
/**
 * @deprecated
 */
export const BodyShort01 = Short01;
/**
 * @deprecated
 */
export const BodyShort02 = Short01;
/**
 * @deprecated
 */
export const Caption01 = HelperText01;
/**
 * @deprecated
 */
export const Label = css`
  ${Label01};
  ${Text02};
`;
/**
 * @deprecated
 */
export const HelperText = css`
  ${HelperText01};
  ${Text02};
`;
